import { Type, Static } from '@sinclair/typebox';
import {
  defineSchema,
  SystemFields,
  RelationField,
  StringField,
  BooleanField,
} from '@ayocore/platform/common/helpers/schema-types';
import dealSchemaDefinition from './deal.schema';

import { name as moduleName } from '../module.json';
/**
 * Версии строк сделки — позволяет хранить несколько наборов позиций.
 */
const DealVersionSchema = Type.Object({
  ...SystemFields,

  deal_id: RelationField(dealSchemaDefinition, 'ID сделки', {
    description: 'Сделка, к которой относится версия строк',
    relationName: 'deal',
  }),

  version: StringField({
    title: 'Номер версии',
    description: 'Порядковый номер версии в рамках одной сделки',
  }),

  description: StringField({
    title: 'Название версии',
    nullable: true,
    maxLength: 255,
  }),

  is_active: BooleanField({
    title: 'Активная версия',
    default: false,
    description: 'Ровно одна активная версия на сделку',
  }),
});

export type DealVersion = Static<typeof DealVersionSchema>;

export default defineSchema({
  moduleName,
  tableName: 'deal_versions', // System will prefix with 'crm_'
  schema: DealVersionSchema,
  additionalIndexes: ['deal_id', 'version', 'is_active'],
  foreignKeys: [],
  dependencies: ['crm_deals'],
});
